import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {loginStates} from 'modules/authentication/constants';
import {loginStateSelector} from 'modules/authentication/selectors';
import {setTitle} from 'modules/a11ycat/actions';

import Message from './Steps/Message';
import Password from './Steps/Password';
import Username from './Steps/Username';

export default function Login() {

    const dispatch = useDispatch();
    const step = useSelector(loginStateSelector);

    const containerStyles = {
        backgroundColor: 'white',
        minWidth: 350,
    };


    let loginStep;
    let pageTitle;
    switch (step) {
        case loginStates.ENTER_USERNAME:
            loginStep = <Username/>;
            pageTitle = 'Login - Enter Username';
            break;
        case loginStates.ENTER_PASSWORD:
            loginStep = <Password/>;
            pageTitle = 'Login - Enter Password';
            break;
        case loginStates.LOGGED_IN:
            // should be redirecting to the homepage by now, but display a message anyway
            loginStep = <Message title="Logged In" message="Thanks!"/>;
            pageTitle = 'Logged In';
            break;
        case loginStates.EXTERNAL:
            loginStep = <Message title="Logging In" message="Authenticating..."/>;
            pageTitle = 'Authenticating...';
            break;
    }

    useEffect(() => {
        dispatch(setTitle(pageTitle));
    }, [pageTitle]);

    return <div style={containerStyles}>
        {loginStep}
    </div>;
}